import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, FormControl, InputGroup, Modal, Nav, Row, Tab, Table, ToggleButton } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FaBan, FaCheck, FaPen, FaTrash } from 'react-icons/fa';
import moment from 'moment';
import { quoteToDoubleQuote } from './utils/Columns';

const InfoToValidate = ({ adherentLight, gotoAuth, reloadData, closemodal }) => {

    const url = localStorage.getItem('url');
    const code = localStorage.getItem('code');
    const [requiredFields, setRequiredFields] = useState([]);
    const dropdown = JSON.parse(localStorage.getItem('dropdown'));

    const [allRequiredFieldsFilled, setAllRequiredFieldsFilled] = useState(false);

    const [adherentInitial, setAdherentInitial] = useState({ ...adherentLight });
    const [adherentClient, setAdherentClient] = useState({ ...adherentLight });
    const [adherentFinal, setAdherentFinal] = useState({ ...adherentLight });

    useEffect(() => {
        getAdherent();
    }, [adherentLight.id]);

    const getAdherent = () => {
        // // Vérifier que appel_cotisation_id existe et est valide
        // if (!adherentLight.appel_cotisation_id || adherentLight.appel_cotisation_id === 'undefined' || adherentLight.appel_cotisation_id === 'null') {
        //     console.error('appel_cotisation_id manquant ou invalide:', adherentLight);
        //     gotoAuth();
        //     return;
        // }

        fetch(`${url}GetAdherentOldNewById/${adherentLight.appel_cotisation_id}/${code}`)
            .then(response => response.json())
            .then(data => {
                if (data === '0' || !data.nouveau)
                    gotoAuth();
                else {
                    console.log('Réponse du serveur:', data);
                    setAdherentInitial({ ...data.old[0] });
                    setAdherentClient({ ...data.nouveau[0] });
                    setAdherentFinal({ ...data.nouveau[0] });
                }
            })
            .catch(error => console.error('Erreur:', error));
    }

    const saveAdherent = () => {
        let myurl = localStorage.getItem('url');

        fetch(`${myurl}SaveMergedAdherent`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            // remplace 'Invalid date' par '' dans le JSON
            body: JSON.stringify(quoteToDoubleQuote(adherentFinal))
        })
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                alert('Données enregistrées. Merci !')
                closemodal();
                reloadData();
                // handleCloseModal();
            })
            .catch(error => console.error('Erreur:', error));
    }

    const formatDate = (libelle, date) => {
        return date && (
            <p>{libelle}: {moment(parseInt(date.slice(6, -2), 10)).format('DD/MM/YYYY')}</p>
        )
    }

    const [previousActiveKey, setPreviousActiveKey] = useState(undefined); // activeKey par défaut
    const [activeKey, setActiveKey] = useState('link-0');
    const [nextActiveKey, setNextActiveKey] = useState('link-1');
    const lastActiveKey = 'link-2'; // dernier activeKey
    // const getactiveKeypositionInTableauData = () => {
    //     let position = 0;
    //     tableauData.forEach((item, index) => {
    //         if (item.key === activeKey)
    //             position = index;
    //     });
    //     return position;
    // }


    const [editedAdherent, setEditedAdherent] = useState({ ...adherentLight });

    const handleInputChange = (field, value) => {
        console.log(field, value);

        let newEditedAdherent = { ...adherentFinal };
        if (field === 'ape_forme_juridique') {
            let valarray = value.split(' - ');
            if (valarray.length === 1)
                newEditedAdherent = { ...adherentFinal, [field]: value, code_ape_ou_naf: valarray[0], forme_juridique_de_la_societe: '' };
            else
                newEditedAdherent = { ...adherentFinal, [field]: value, code_ape_ou_naf: valarray[0], forme_juridique_de_la_societe: valarray[1] };
        } else if (['numero_de_portable', 'telephone'].includes(field)) {
            const phoneNumber = value.replace(/\s/g, '');
            let formattedPhoneNumber = "";
            if (phoneNumber.length === 3)
                formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{1})/, '$1 $2');
            else if (phoneNumber.length === 4)
                formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{2})/, '$1 $2');
            else if (phoneNumber.length === 5)
                formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{2})(\d{1})/, '$1 $2 $3');
            else if (phoneNumber.length === 6)
                formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{2})(\d{2})/, '$1 $2 $3');
            else if (phoneNumber.length === 7)
                formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{1})/, '$1 $2 $3 $4');
            else if (phoneNumber.length === 8)
                formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4');
            else if (phoneNumber.length === 9)
                formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{1})/, '$1 $2 $3 $4 $5');
            else if (phoneNumber.length === 10)
                formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
            else
                formattedPhoneNumber = phoneNumber;
            newEditedAdherent = { ...adherentFinal, [field]: formattedPhoneNumber };
        } else if (field === 'nbre_productifs') {
            newEditedAdherent = { ...adherentFinal, [field]: value, total_personnel: parseInt(value) + parseInt(adherentFinal.nbre_apprentis) };
        } else if (field === 'nbre_apprentis') {
            newEditedAdherent = { ...adherentFinal, [field]: value, total_personnel: parseInt(value) + parseInt(adherentFinal.nbre_productifs) };
        } else {
            newEditedAdherent = { ...adherentFinal, [field]: value };
        }

        setAdherentFinal(newEditedAdherent);
        const areAllRequiredFieldsFilled = requiredFields.every(field => newEditedAdherent[field].trim() !== '');
        setAllRequiredFieldsFilled(areAllRequiredFieldsFilled);
    };


    const getInput = (libelle, field, required) => {

        if (required && !requiredFields.includes(field))
            setRequiredFields([...requiredFields, field]);

        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        return <InputGroup className="mb-3" key={libelle} style={{ width: '100%' }}>
            <InputGroup.Text style={{ width: '25%', minWidth: '100px', textAlign: 'left' }}>
                {libelle}{required && <span style={{ color: 'red' }}>&nbsp;*</span>}
            </InputGroup.Text>
            {adherentInitial[field] === adherentFinal[field] &&
                <Button variant="outline-success" style={{ width: '25%' }} id="button-addon1">
                    {adherentInitial[field]}
                </Button>}
            {adherentInitial[field] !== adherentFinal[field] &&
                <Button variant="outline-danger" style={{ width: '25%' }} id="button-addon1" onClick={() => handleInputChange(field, adherentInitial[field])}>
                    {adherentInitial[field]}
                </Button>}

            {adherentClient[field] === adherentFinal[field] &&
                <Button variant="outline-success" style={{ width: '25%' }} id="button-addon1">
                    {adherentClient[field]}
                </Button>}
            {adherentClient[field] !== adherentFinal[field] &&
                <Button variant="outline-danger" style={{ width: '25%' }} id="button-addon1" onClick={() => handleInputChange(field, adherentClient[field])}>
                    {adherentClient[field]}
                </Button>}


            <FormControl
                style={{ flex: 1, minWidth: '100px', textAlign: 'center' }}
                value={adherentFinal[field]}
                onChange={(e) => handleInputChange(field, e.target.value)}
            />
        </InputGroup>

    }

    const getText = (libelle, field) => {
        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        return <InputGroup className="mb-3" key={libelle} style={{ display: 'flex' }}>
            <InputGroup.Text style={{ width: '25%', minWidth: '100px', textAlign: 'left' }}>{libelle}</InputGroup.Text>
            <InputGroup.Text className="text-center" style={{ flex: 1, minWidth: '100px', justifyContent: 'center' }}>
                {adherentFinal[field]}
            </InputGroup.Text>
        </InputGroup>
    }

    const getInputNumber = (libelle, field) => {
        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        return <InputGroup className="mb-3" key={libelle} style={{ width: '100%' }}>
            <InputGroup.Text style={{ width: '25%', minWidth: '100px', textAlign: 'left' }}>{libelle}</InputGroup.Text>
            {adherentInitial[field] === adherentFinal[field] &&
                <Button variant="outline-success" style={{ width: '25%' }} id="button-addon1">
                    {adherentInitial[field]}
                </Button>}
            {adherentInitial[field] !== adherentFinal[field] &&
                <Button variant="outline-danger" style={{ width: '25%' }} id="button-addon1" onClick={() => handleInputChange(field, adherentInitial[field])}>
                    {adherentInitial[field]}
                </Button>}

            {adherentClient[field] === adherentFinal[field] &&
                <Button variant="outline-success" style={{ width: '25%' }} id="button-addon1">
                    {adherentClient[field]}
                </Button>}
            {adherentClient[field] !== adherentFinal[field] &&
                <Button variant="outline-danger" style={{ width: '25%' }} id="button-addon1" onClick={() => handleInputChange(field, adherentClient[field])}>
                    {adherentClient[field]}
                </Button>}

            <FormControl
                min='0'
                type='number'
                style={{ flex: 1, minWidth: '100px', textAlign: 'center' }}
                value={adherentFinal[field]}
                onChange={(e) => handleInputChange(field, e.target.value)}
            />
        </InputGroup>

    }

    const getDate = (libelle, field, value) => {
        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        return <InputGroup className="mb-3" key={libelle}>
            <InputGroup.Text>{libelle}</InputGroup.Text>
            <FormControl
                type='date'
                value={adherentFinal[field]}
                onChange={(e) => handleInputChange(field, e.target.value)}
            />
        </InputGroup>

    }

    const getYesNo = (libelle, field) => {
        return <InputGroup className="mb-3" key={libelle} style={{ width: '100%' }}>
            <InputGroup.Text style={{ width: '25%', minWidth: '100px', textAlign: 'left' }}>{libelle}</InputGroup.Text>
            {adherentInitial[field] === adherentFinal[field] &&
                <Button variant="outline-success" style={{ width: '25%' }} id="button-addon1" onClick={() => handleInputChange(field, adherentInitial[field])}>
                    {adherentInitial[field] === 1 ? 'Oui' : 'Non'}
                </Button>}
            {adherentInitial[field] !== adherentFinal[field] &&
                <Button variant="outline-danger" style={{ width: '25%' }} id="button-addon1" onClick={() => handleInputChange(field, adherentInitial[field])}>
                    {adherentInitial[field] === 1 ? 'Oui' : 'Non'}
                </Button>}

            {adherentClient[field] === adherentFinal[field] &&
                <Button variant="outline-success" style={{ width: '25%' }} id="button-addon1" onClick={() => handleInputChange(field, adherentClient[field])}>
                    {adherentClient[field] === 1 ? 'Oui' : 'Non'}
                </Button>}
            {adherentClient[field] !== adherentFinal[field] &&
                <Button variant="outline-danger" style={{ width: '25%' }} id="button-addon1" onClick={() => handleInputChange(field, adherentClient[field])}>
                    {adherentClient[field] === 1 ? 'Oui' : 'Non'}
                </Button>}
            <ToggleButton
                id={"toggle-check" + field}
                type="checkbox"
                variant={adherentFinal[field] === 1 ? 'success' : 'danger'}
                checked={adherentFinal[field] === 1}
                style={{ flex: 1, minWidth: '100px', textAlign: 'center' }}
                value={adherentFinal[field]}
                onChange={(e) => handleInputChange(field, adherentFinal[field] === 0 ? 1 : 0)}
            >
                {adherentFinal[field] === 1 ? 'Oui' : 'Non'}
            </ToggleButton>
        </InputGroup>
    }

    const getSelect = (libelle, field, options) => {
        return <InputGroup className="mb-3" key={libelle} style={{ width: '100%' }}>
            <InputGroup.Text style={{ width: '25%', minWidth: '100px', textAlign: 'left' }}>{libelle}</InputGroup.Text>
            {adherentInitial[field] === adherentFinal[field] &&
                <Button variant="outline-success" style={{ width: '25%' }} id="button-addon1">
                    {adherentInitial[field]}
                </Button>}
            {adherentInitial[field] !== adherentFinal[field] &&
                <Button variant="outline-danger" style={{ width: '25%' }} id="button-addon1" onClick={() => handleInputChange(field, adherentInitial[field])}>
                    {adherentInitial[field]}
                </Button>}

            {adherentClient[field] === adherentFinal[field] &&
                <Button variant="outline-success" style={{ width: '25%' }} id="button-addon1">
                    {adherentClient[field]}
                </Button>}
            {adherentClient[field] !== adherentFinal[field] &&
                <Button variant="outline-danger" style={{ width: '25%' }} id="button-addon1" onClick={() => handleInputChange(field, adherentClient[field])}>
                    {adherentClient[field]}
                </Button>}

            <Form.Select
                value={adherentFinal[field]}
                onChange={(e) => handleInputChange(field, e.target.value)}
                style={{ flex: 1, minWidth: '100px', textAlign: 'center' }}

            >
                {options.map((item, index) => (
                    <option key={index} value={item}>{item}</option>
                ))}
            </Form.Select>
        </InputGroup>
    }

    const tableauData = [
        {
            key: 'link-0', libelle: 'Informations adhérent', requiredFieldsFilled: false, corps: <>
                {getSelect('Civilité', 'civilite', dropdown.filter(el => el.type === 'civilite').map(el => (el.libelle)))}
                {getInput('Prénom', 'prenom_adherent', true)}
                {getInput('Nom', 'nom_adherent', true)}
                {getInput('Adresse', 'adresse1', true)}
                {getInput('Complément adresse', 'adresse2')}
                {getInput('Code Postal', 'code_postal', true)}
                {getInput('Ville', 'ville', true)}
                {getInput('Téléphone 1', 'telephone', true)}
                {getInput('Téléphone 2', 'numero_de_portable')}
                {getInput('E-mail', 'e_mail_1', true)}
                {/* {getInput('Région', 'region', editedAdherent.region)} */}
            </>
        },
        {
            key: 'link-1', libelle: 'Entreprise', requiredFieldsFilled: false, corps: <>
                {getInput('Entreprise', 'nom_de_l_entreprise')}
                {getInput('Siret', 'siret')}
                {getInput('Numéro TVA Intracommunautaire', 'numero_tva_intracommunautaire')}
                {/* {getSelect('Forme Juridique', 'ape_forme_juridique', dropdown.filter(el => el.type === 'ape').map(el => {
                    // console.log(el.ref)
                    return el.libelle + (Object.keys(el.ref).length !== 0 ? ' - ' + el.ref : '')
                }))} */}

                {getSelect('Code APE ou NAF', 'code_ape_ou_naf', dropdown.filter(el => el.type === 'ape').map(el => el.libelle))}
                {getSelect('Forme Juridique', 'forme_juridique_de_la_societe', dropdown.filter(el => el.type === 'societe').map(el => el.libelle))}

                {/* {getInput('Code APE ou NAF', 'code_ape_ou_naf', editedAdherent.code_ape_ou_naf)}
                {getInput('Forme Juridique', 'forme_juridique_de_la_societe', editedAdherent.forme_juridique_de_la_societe)} */}
                {getInputNumber('Montant du Capital', 'montant_du_capital')}
                {getInput('Code Métier', 'code_metier')}
            </>
        },
        {
            key: 'link-2', libelle: 'Effectif', requiredFieldsFilled: false, corps: <>
                {getInputNumber('Nombre Productifs', 'nbre_productifs')}
                {getInputNumber('Nombre Apprentis', 'nbre_apprentis')}
                {getText('Total Personnel', 'total_personnel')}
            </>
        },
        // {
        //     key: 'link-3', libelle: 'Abonnement', requiredFieldsFilled: false, corps: <>
        //         {getYesNo('Accès Site FFC Newsletter', 'acces_site_ffc_newsletter')}
        //         {/* {getInput('Accès Site FFC Newsletter', 'acces_site_ffc_newsletter', editedAdherent.acces_site_ffc_newsletter)} */}
        //         {getYesNo('Abonné FFC Expert', 'abonne_ffc_expert')}
        //         {getYesNo('Abonné Mag Carrosserie', 'abonne_mag_carrosserie')}
        //         {getYesNo('Abonné Profession Carrossier', 'abonne_profession_carrossier')}
        //         {getYesNo('Accès Médiateur Consommation', 'acces_mediateur_consommation')}
        //     </>
        // },
        // { key: 'link-4', libelle: 'Tribu' },
    ];

    const renderModalContent = (key) => {
        let data = tableauData.find(el => el.key === key);

        return (
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between">
                        <h5>{data.libelle}</h5>
                    </div>
                </Card.Header>
                <Card.Body>
                    {data.corps}
                </Card.Body>
            </Card>
        );
    }

    const handleNextTab = () => {
        // Call the onUpdateAdherent function with the updated data
        let position = 0;
        tableauData.forEach((item, index) => {
            if (item.key === activeKey)
                position = index;
        });
        setPreviousActiveKey(activeKey);
        setActiveKey(tableauData[position + 1].key);
    }

    const handlePreviousTab = () => {
        // Call the onUpdateAdherent function with the updated data
        let position = 0;
        tableauData.forEach((item, index) => {
            if (item.key === activeKey)
                position = index;
        });
        setActiveKey(previousActiveKey);
        setPreviousActiveKey(position === 0 ? undefined : tableauData[position - 1].key);
    }

    return (
        <div>
            <Tab.Container activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                {/* <Nav variant="tabs">
                    {tableauData.map((item, index) => (
                        <Nav.Item key={index}>
                            <Nav.Link eventKey={item.key}>{item.libelle}</Nav.Link>
                        </Nav.Item>
                    ))}
                </Nav> */}
                <Tab.Content>
                    {tableauData.map((item, index) => (
                        <Tab.Pane eventKey={item.key}>
                            <Card>
                                <Card.Body>
                                    {renderModalContent(item.key)}
                                </Card.Body>
                            </Card>
                        </Tab.Pane>
                    ))}
                </Tab.Content>
            </Tab.Container>

            <div className="d-grid gap-2">
                {previousActiveKey !== undefined &&
                    // setActiveKey(key)            
                    <Button variant="primary" size='lg' onClick={handlePreviousTab} >Précédent</Button>
                }
                {activeKey !== lastActiveKey &&
                    // setActiveKey(key)            
                    <Button variant="primary" size='lg' onClick={handleNextTab} >Suivant</Button>
                }
                {activeKey === lastActiveKey &&
                    <Button variant="primary" size='lg' onClick={saveAdherent}>Enregistrer</Button>
                }
            </div>

        </div >
    );
}

export default InfoToValidate;
